import { ANALYTICS_PROVIDER, LOCAL_STORAGE_KEY } from "../constant";
import { utility } from "../utility/utility";
import { initGA4, logEventGA4 } from "./ga4AnalytocsHelper";
import { initMixpanel, logEventMixpanel } from "./mixpanelAnalyticsHelper";

const AnalyticsManager = () => {

    const init = (analyticConfig) => {
        let initialized = false;
        switch (analyticConfig?.SID) {
            case ANALYTICS_PROVIDER.GoogleAnalytics:
                initGA4({
                    measurementId: analyticConfig?.Config?.measurementId ?? "G-20M0DPLJMF",
                    userId: analyticConfig?.userId ?? "",
                });
                initialized = true;
                break;
            case ANALYTICS_PROVIDER.MixPanel:
                initMixpanel({
                    token: analyticConfig?.Config?.Token ?? "",
                    userId: analyticConfig?.userId ?? "",
                });
                initialized = true;
                break;
            default:
                console.warn("Unsupported analytics provider:", analyticConfig?.SID);
        }
        if (initialized) {
            console.log("Set analytics type:", analyticConfig?.SID);
            utility.setValue(LOCAL_STORAGE_KEY.analyticType, analyticConfig?.SID);
        }
    };

    const logEvent = (eventName, params = {}) => {
        let analyticType = utility.getValue(LOCAL_STORAGE_KEY.analyticType);
        console.log(analyticType);

        switch (analyticType) {
            case ANALYTICS_PROVIDER.GoogleAnalytics:
                logEventGA4(eventName, params);
                break;
            case ANALYTICS_PROVIDER.MixPanel:
                logEventMixpanel(eventName, params);
                break;
            default:
                console.warn("logEvent not implemented for:", analyticType);
        }
    };

    return { init, logEvent };
};

export default AnalyticsManager;
